import { lazy, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { routes } from '@/config/routes';

const InstallerJoin = lazy(() => import('@/pages/Installer/Join'));
const InstallerProject = lazy(() => import('@/pages/Installer/Project'));

/**
 * Public deep-link routes for the Flutter Installer app.
 * No authentication required — these URLs are opened by the mobile OS
 * universal link handler and must resolve without a login redirect.
 */
export const InstallerRoutes = (
    <Fragment>
        <Route path={routes.installer.join} element={<InstallerJoin />} />
        <Route path={routes.installer.project} element={<InstallerProject />} />
    </Fragment>
);
